export const KEY = {
  USER: 'USER',
  TOKEN_ACCESS: 'TOKEN_ACCESS',
  REFRESH_ACCESS: 'REFRESH_ACCESS',
  SIGNATURE: 'SIGNATURE',
};

export const ITEM_PER_PAGE = 10;
export const WALLET = 'wallet';
export const WALLETCONNECT = 'walletconnect';
export const MAX_DECIMAL = 6;
export const MAX_UINT256 =
  '115792089237316195423570985008687907853269984665640564039457584007913129639935';
